/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Quick_Action_SublineInputs */

const de_billing_quick_action_subline = /** @type {(inputs: Billing_Quick_Action_SublineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsmethoden verwalten`)
};

/** @type {(inputs: Billing_Quick_Action_SublineInputs) => LocalizedString} */
const en_billing_quick_action_subline = de_billing_quick_action_subline;

/**

* @param {Billing_Quick_Action_SublineInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_quick_action_subline = /** @type {((inputs?: Billing_Quick_Action_SublineInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Quick_Action_SublineInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_billing_quick_action_subline(inputs)
	return en_billing_quick_action_subline(inputs)
});